import { settings } from './settings';
import { unformat, unformatArray } from './unformat';
import { toFixed } from './toFixed';
import { formatNumber, formatNumberArray } from './formatNumber';
import { formatMoney, formatMoneyArray } from './formatMoney';
import { CurrencyFormat, Settings } from './types';

export {
  settings,
  unformat,
  unformatArray,
  toFixed,
  formatMoney,
  formatMoneyArray,
  formatNumber,
  formatNumberArray,
};

export type {
  Settings,
  CurrencyFormat,
};
